import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6133nhkv31: FaireBrandEntity = {
  token: "b_6133nhkv31",
  type: "brand",
  name: "ELIETIAN",
  avatarUrl:
    "https://cdn.faire.com/fastly/8984c53be26d460a5867a9822f9fbc4d2b0a53cb39142a07f1225b37bc417259.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8c906b2f0f4f6b0addf8b77bf6bf201124c75713f5d9c9e8d03beabe4740b794.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8984c53be26d460a5867a9822f9fbc4d2b0a53cb39142a07f1225b37bc417259.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8c906b2f0f4f6b0addf8b77bf6bf201124c75713f5d9c9e8d03beabe4740b794.png",
  location: "Seneca, SC, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 47,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a Women's Basics Company that is revolutionizing the fashion industry with our high-quality, luxuriously soft materials. Our mission is to provide women with all-day comfort, boosting their confidence and empowering them to conquer each day. With our seamless construction and 4-way stretch, our everyday products are designed to accommodate an active lifestyle, allowing for full freedom of movement and all day comfort.\n\nWe offer a wide selection of timeless & form flattering silhouettes that are the base to every great outfit.  Featuring our exclusive Rayon fabrication, our buttery soft collections are crafted to give a gentle hug and a smoothing finish.\n\nWe offer 2 inclusive fits - Regular (0-12) & Curvy (10-22).\n\nPlease reach out with any questions, sample requests, or marketing needs!\n\nContact Us: Natalie [redacted-phone] or Allison [redacted-phone]\nEmail: [redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:36.186Z",
    importedBy: "entity-db-cli",
  },
};
